export const toPath = (key) => {
  if (typeof key !== "string") return "/";
  if (key === "dashboard") return "/";
  return key.startsWith("/") ? key : `/${key}`;
};

export const matchesPath = (pathname, key) => {
  const target = toPath(key);
  if (target === "/") return pathname === "/";
  return pathname === target || pathname.startsWith(`${target}/`);
};

export const childKeys = (item) =>
  (item?.children ?? []).map((c) => c?.key).filter((k) => typeof k === "string");

export const isModuleActive = (item, pathname) => {
  if (!item || typeof item.key !== "string") return false;
  return [item.key, ...childKeys(item)].some((k) => matchesPath(pathname, k));
};

export const activeChildKey = (children, pathname) =>
  (children ?? [])
    .filter((c) => typeof c?.key === "string")
    .filter((c) => matchesPath(pathname, c.key))
    .sort((a, b) => toPath(b.key).length - toPath(a.key).length)[0]?.key;
